<template>
  <div class="p-5 bg-white shadow overflow-hidden sm:rounded-lg w-full sm:mt-6">
    <div class="space-y-8 divide-y divide-gray-200">
      <div class="space-y-8 divide-y divide-gray-200">
        <div>
          <div>
            <h3
              v-if="update"
              class="text-lg leading-6 font-medium text-gray-900"
            >
              Update Studio
            </h3>
            <h3
              v-if="!update"
              class="text-lg leading-6 font-medium text-gray-900"
            >
              Create new Studio
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Use a permanent address where you can receive mail.
            </p>
          </div>

          <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3" v-if="user.type == 'admin'">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Studio owners
              </label>
              <div v-for="(owner, index) in studio.owner" :key="index">
                <div
                  @click="
                    studio.owner = studio.owner.filter(
                      (item) => item._id !== owner._id
                    )
                  "
                >
                  <div class="py-4">
                    <div class="flex items-center space-x-4">
                      <div class="flex-shrink-0">
                        <span
                          class="inline-flex items-center justify-center h-8 w-8 rounded-full"
                          v-bind:style="{
                            backgroundColor: getRGB(owner.email),
                          }"
                        >
                          <span
                            class="text-sm font-medium leading-none text-white"
                            >{{ owner.email[0] }}</span
                          >
                        </span>
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-900 truncate">
                          {{ owner.firstname }} {{ owner.lastname }}
                        </p>
                        <p class="text-sm text-gray-500 truncate">
                          {{ owner.email }}
                        </p>
                      </div>
                      <div>
                        <a
                          href="#"
                          class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-700"
                        >
                          Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <select
                  id="country"
                  name="country"
                  autocomplete="country"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="selectedOwner"
                  @change="addOwner()"
                >
                  <option
                    v-for="user in customers"
                    :value="user"
                    :key="user._id"
                  >
                    {{ user.firstname }}
                  </option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-3" v-if="user.type == 'admin'">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Cleaner
              </label>
              <div v-for="(cleaner, index) in studio.cleaner" :key="index">
                <div
                  @click="
                    studio.cleaner = studio.cleaner.filter(
                      (item) => item._id !== cleaner._id
                    )
                  "
                >
                  <div class="py-4">
                    <div class="flex items-center space-x-4">
                      <div class="flex-shrink-0">
                        <span
                          class="inline-flex items-center justify-center h-8 w-8 rounded-full"
                          v-bind:style="{
                            backgroundColor: getRGB(cleaner.email),
                          }"
                        >
                          <span
                            class="text-sm font-medium leading-none text-white"
                            >{{ cleaner.email[0] }}</span
                          >
                        </span>
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-900 truncate">
                          {{ cleaner.firstname }} {{ cleaner.lastname }}
                        </p>
                        <p class="text-sm text-gray-500 truncate">
                          {{ cleaner.email }}
                        </p>
                      </div>
                      <div>
                        <a
                          href="#"
                          class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-700"
                        >
                          Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-1">
                <select
                  id="country"
                  name="country"
                  autocomplete="country"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="selectedCleaner"
                  @change="addCleaner()"
                >
                  <option
                    v-for="user in cleaners"
                    :value="user"
                    :key="user._id"
                  >
                    {{ user.firstname }}
                  </option>
                </select>
              </div>
            </div>
            <div class="sm:col-span-6">
              <label
                for="about"
                class="block text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <div class="mt-1">
                <textarea
                  id="about"
                  name="about"
                  rows="3"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.description"
                ></textarea>
              </div>
              <p class="mt-2 text-sm text-gray-500">
                Write a few sentences about the studio, such as the layout,
                where to find things and common expected tasks.
              </p>
            </div>

            <div class="sm:col-span-3" v-if="user.type == 'admin'">
              <label for="city" class="block text-sm font-medium text-gray-700">
                Expected cleaning cost
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.cleaningCost"
                />
              </div>
            </div>

            <div class="sm:col-span-3" v-if="user.type == 'admin'">
              <label for="city" class="block text-sm font-medium text-gray-700">
                Expected cleaner cost
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.cleanerCost"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Available from
              </label>
              <div class="mt-1">
                <date-picker
                  v-model="studio.startHour"
                  type="time"
                  :placeholder="studio.startHour | moment('timezone', 'Europe/Brussels','HH:mm')"
                ></date-picker>
              </div>
            </div>

            <div class="sm:col-span-3">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Available to
              </label>
              <div class="mt-1">
                <date-picker
                  v-model="studio.endHour"
                  type="time"
                  :placeholder="studio.endHour | moment('timezone', 'Europe/Brussels','HH:mm')"
                ></date-picker>
              </div>
            </div>
          </div>
          <div class="pt-8">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Personal Information
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Use a permanent address where you can receive mail.
            </p>
          </div>
          <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Country / Region
              </label>
              <div class="mt-1">
                <select
                  id="country"
                  name="country"
                  autocomplete="country"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.country"
                >
                  <option>Belgium</option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-6">
              <label
                for="street_address"
                class="block text-sm font-medium text-gray-700"
              >
                Street address
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="street_address"
                  id="street_address"
                  autocomplete="street-address"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.street"
                />
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="city" class="block text-sm font-medium text-gray-700">
                City
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.city"
                />
              </div>
            </div>

            <div class="sm:col-span-2">
              <label
                for="state"
                class="block text-sm font-medium text-gray-700"
              >
                State / Province
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="state"
                  id="state"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.region"
                />
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="zip" class="block text-sm font-medium text-gray-700">
                ZIP / Postal
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="zip"
                  id="zip"
                  autocomplete="postal-code"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="studio.zipCode"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-5">
        <div class="flex justify-end">
          <button
            @click="goto('/studios')"
            type="button"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            v-if="!update"
            @click="createStudio()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Create Studio
          </button>
          <button
            v-if="update"
            @click="updateStudio()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Update Studio
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import avatarGenerator from './../../../services/avatarGenerator'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
  name: 'createJob',
  data() {
    return {
      update: false,
      studio: {
        owner: [],
        cleaner: [],
      },
      selectedCleaner: null,
      selectedOwner: null,
    }
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters('user', {
      user: 'currentUser',
    }),
    ...mapGetters('studio', {
      studios: 'studioList',
    }),
    ...mapGetters('users', {
      users: 'userList',
    }),
    cleaners() {
      return this.users.filter((user) => {
        return user.type == 'cleaner'
      })
    },
    customers() {
      return this.users.filter((user) => {
        return user.type == 'customer'
      })
    },
  },
  methods: {
    getRGB(name) {
      return avatarGenerator.getRGB(name)
    },
    addOwner() {
      this.studio.owner.push(this.selectedOwner)
    },
    addCleaner() {
      console.log("Add Cleaner method invoked");
      //Only parse the id of the cleaner. Original code above
      if (this.selectedCleaner) {
        const { _id, firstname, lastname, email } = this.selectedCleaner;
        const cleanerObject = { _id, firstname, lastname, email };
        this.studio.cleaner.push(cleanerObject);
        console.log(cleanerObject);
      }
    },
    createStudio() {
      let start = new Date(this.studio.startHour)
      let userTimezoneOffset = start.getTimezoneOffset() * 60000;
      let start_date = new Date(start.getTime() - userTimezoneOffset);
      start_date = new Date(start_date.getHours() +1);
      this.studio.startHour = start_date.toISOString()  

      let end = new Date(this.studio.endHour)
      let userTimezoneOffsetend = end.getTimezoneOffset() * 60000;
      let end_date = new Date(end.getTime() - userTimezoneOffsetend);
      end_date = new Date(end_date.getHours() +1);
      this.studio.endHour = end_date.toISOString()

      this.$store.dispatch('studio/createStudio', this.studio)
      this.$router.push('/studios')
    },
    updateStudio() {
      let start = new Date(this.studio.startHour)
      let userTimezoneOffset = start.getTimezoneOffset() * 60000;
      let start_date = new Date(start.getTime() - userTimezoneOffset - 3600000);
      this.studio.startHour = start_date.toISOString()  

      let end = new Date(this.studio.endHour)
      let userTimezoneOffsetend = end.getTimezoneOffset() * 60000;
      let end_date = new Date(end.getTime() - userTimezoneOffsetend - 3600000);      
      this.studio.endHour = end_date.toISOString()

      this.$store.dispatch('studio/updateStudio', this.studio)
      this.$router.push('/studios')
    },
    goto(path) {
      this.$router.push({ path })
    },
    getStudioById(id) {
      let filtered = this.studios.filter((studio) => {
        if (studio._id == id) return studio
      })
      return filtered[0]
    },
  },
  mounted() {
    if (this.$route.params.index) {
      this.index = this.$route.params.index
      this.studio = this.getStudioById(this.index)
      this.update = true
    }
  },
}
</script>

<style>
.mx-datepicker {
  width: 100%;
}

.mx-datepicker input {
  border-radius: 0.375rem;
  appearance: none;
  background-color: #fff;
  border-color: rgb(173, 173, 173);
  border-width: 1px;
  padding-top: 1.1rem;
  padding-right: 0.75rem;
  padding-bottom: 1.1rem;
  padding-left: 0.75rem;
}
</style>
